export function ParseMillisecondsToSeconds(millisecond) {
  return millisecond 
    ? Math.round(((millisecond % 60000) / 1000) * 10) / 10
    : 0;
}
